import { forwardRef, InputHTMLAttributes } from 'react';

import { TextInput } from '../../inputs/TextInput/TextInput';
import { DefaultFormFieldLayout } from '../DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '../FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldTextProps = {
  inputProps: InputHTMLAttributes<HTMLInputElement>;
  label?: React.ReactNode;
  error?: string;
  helperText?: HelperText;
  inline?: boolean;
  // TODO: Use the following dupes instead of inputProps?
  // Sometimes we may want the raw event I guess?
  // No references use either of these yet
  // onChange?: (value: any) => void;
  // value?: string;
  // placeholder?: string;
  // disabled?: boolean;
  // This was originally passed to the layout component in FormField but no references
  // to this component use it
  // Figure we can think about it more
  // className?: string;
};

export const CoreFormFieldText = forwardRef(function _CormFormFieldText(
  { error, helperText, inline, inputProps, label }: CoreFormFieldTextProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      error={error}
      inputId={inputProps.id}
      inline={inline}
      helperText={helperText}
    >
      <div className="relative flex items-center">
        <TextInput
          data-testid={inputProps.id}
          {...inputProps}
          error={error}
          ref={ref}
          type="text"
        />
      </div>
    </DefaultFormFieldLayout>
  );
});
